import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BuyLoaderService {
  showLoader: Subject<boolean> = new Subject<boolean>();

  displayLoader() {
    this.showLoader.next(true);
  }

  hideLoader() {
    this.showLoader.next(false);
  }
}
